import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {Grid, InputBase, makeStyles, Menu, MenuItem, Theme, Typography} from '@material-ui/core'
import {primaryBlue, primaryGray, white} from 'src/components/colors';
import {DownArrowIcon, PlusIcon, UpArrow} from 'src/components/Icons';
import useStyles from "src/app/maintenance/assets/styles";


export function DropDownRMOTA(props) {
  const classes = local();
  const style = useStyles();
  const [isDropDown, setIsDropDown] = useState(false)
  const dropdownRef = useRef(null);
  const [selectOptions,setSelectOptions] = useState([])
  const [searchQuery,setSearchQuery] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openEl = Boolean(anchorEl);

  const handleValue = (e) => {
    if (props.type == 'kitModel') {
      handleKitModels(e)
      setSearchQuery(e)
    } else if (props.type == 'batchNumber') {
      handleBatchNumber(e)
    } else if (props.type == 'versionEdit') {
      if(e.versionNum){
        setSearchQuery(e.versionNum);
      }
      props.onClick(e);
    } else if (props.type == 'parameter') {
      if(e.parameter){
        setSearchQuery(e.parameter);
      }
      props.onClick(e);
    } else {
      setSearchQuery('')
      props.onClick(e);
    }
    
  }

  const handleBatchNumber = (e) => {
    props.setSelectOption(e.toString())
    props.setBatchNumber(e.toString());
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropDown(false)
      }
    };


    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDropDown = () => {
    if (props.kitModelFormType !== 'Edit'||props.type!=="parameter") {
    if (!props.disabled && anchorEl==null) {
       setAnchorEl(dropdownRef.current);
    }
    else{
          setAnchorEl(null);
    }
        setSelectOptions(props.options)
      }
  };

  useEffect(() => {
    if (typeof props.value === 'string') {
      setSearchQuery(props.value);
    }
    if (props.type == 'versionEdit'&&props.value!=null) {
      if(props.value.versionNum){
        setSearchQuery(props.value.versionNum);
      }
    } else if (props.type == 'parameter'&&props.value!=null) {
      if(props.value.parameter){      
      setSearchQuery(props.value.parameter);}
    }
  }, [props.value]);

  const handleAddClick = () => {
    props.setIsAddClick(true)
    const isDropDownClick = openEl;
    if (isDropDownClick == true) {
      setAnchorEl(null);
    }
  }

  const handleKitModels = (e) => {
    props.setSelectKitModel(e)
    console.log(e)
    props.setModelError({error: false, errorMessage: ''})

  }
  const handleClose = () => {
    setAnchorEl(null);
  }

  

  const handleSearchOption = (event) =>{
    if(props.type != 'option' && props.type != 'batchNumber'){

      const value = event.target.value
      console.log(props.type)
      setSearchQuery(value);
      if (props.kitModelFormType !== 'Edit') {
        if(value == ''){
          setSelectOptions(props.options)
        }else{
          if (props.type === "parameter") {
            const filterOption = props.options.filter((option) => option.parameter.toLowerCase().includes(value.toLowerCase()))
            console.log(filterOption)
            setSelectOptions(filterOption);
            props.handleParameterCreate( value, value.length > 0);
          }else {
            const filterOption = props.options.filter((option) => option.toLowerCase().includes(value.toLowerCase()))
            console.log(filterOption)
            setSelectOptions(filterOption)
        }}
      }
    }
    
  }


  return (
    <Grid ref={dropdownRef} container style={{height: '44px',width:'100%',position:"relative"}}>
      <Grid container className={style.formInput} 
            style={{border: props.borderStyle||'1px solid #e0e0e0', backgroundColor: white, paddingRight: '0', cursor: 'pointer',margin:'0px',height:"100%"}}
            alignContent='center' onClick={ handleDropDown}>
        <Grid item xs={11} md={11}>
          <InputBase
            type="text"
            placeholder={props.type == 'option' ? props.placeholder : props.emptyTag}
            classes={{ input: props.applyCustomPlaceholder ? classes.input : classes.inputBaseCustom }}
            value={
              (props.type === 'option' || props.type === 'batchNumber') 
                ? (typeof props.value === 'object' && props.value !== null 
                    ? (props.value.label || props.value.name || props.value.toString() || '')
                    : (props.value || ''))
                : props.type=="commandType"?searchQuery.replace(/_/g,' '):searchQuery
            }
            onChange={handleSearchOption}
            fullWidth
            autoFocus
          />
        </Grid>
        {props.kitModelFormType !== 'Edit' ?
          <Grid item xs={1} md={1} style={{textAlign: 'center'}}>
            {openEl ? <UpArrow/> : <DownArrowIcon/>}
          </Grid>
          :
          <></>

        }

      </Grid>

          {props.isAddRequired ?
            <Grid item className={style.option} onClick={() => handleAddClick()}>
              <Grid container style={{marginTop: '5px'}}>
                <Grid item style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: white,
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px'
                }}>
                  <PlusIcon/>
                </Grid>
                <Typography
                  style={{paddingLeft: '10px'}}>{props.type == 'batchNumber' ? props.addTag : props.emptyTag}</Typography>
              </Grid>
            </Grid>
            :
            <></>

          }

           <Menu
          anchorEl={anchorEl}
          open={openEl}
          onClose={handleClose}
          disablePortal={false} 
          className={classes.dropdownMenu}
          PaperProps={{
              style: {
                width: dropdownRef.current&&dropdownRef.current.clientWidth || 'auto',
                top:"210px",
                overflowY: 'auto',
                maxHeight: '200px',
              }
            }}
        >
          {selectOptions.map((option, index) => {
            return (

             <MenuItem className={style.option} onClick={() => {
                handleValue(option); if (props.isSingle) handleDropDown();
              }} key={index}>
                {typeof option === 'object' ? props.type==="parameter"?option.parameter : props.type=="versionEdit"?option.versionNum:option.label :  props.type==="version"?<span style={{color:option.includes("[major]")?"blue":"black"}}>{option.replace(/\s*\[major\]$/, "")}</span>:props.type=="commandType"?  option.replace(/_/g,' '):option}

              </MenuItem>
            )

          })

          }
          </Menu>



    </Grid>
  )

}

const local= makeStyles((theme: Theme) => ({
  input: {
    "&::placeholder": {
      color: primaryGray,  
      opacity: 1, 
      fontFamily: "'Poppins', sans-serif",
      fontSize:'14px'
    }
  },
  inputBaseCustom: {
    border: 'none',
    cursor: 'pointer',
    backgroundColor: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontSize: '13px',
  },
  dropdownMenu: {
    marginTop: '40px',
    width: '100%',}
}));


